import { render, staticRenderFns } from "./M2hContinueJourney.vue?vue&type=template&id=3cb53530&scoped=true&"
import script from "./M2hContinueJourney.vue?vue&type=script&lang=js&"
export * from "./M2hContinueJourney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb53530",
  null
  
)

export default component.exports